
import { defineComponent } from "vue";
import Approved from "@/assets/images/approved.svg";

export default defineComponent({
  components: {
    Approved,
  },
});
